<template>
  <section>
    <!--<h1>欢迎进入管理系统</h1>-->
  </section>
</template>


<script>
  /*编写页面静态部分，即model及vm部分*/

  // import {Card} from "element-ui";

  export default {
    data() {
      return {
      }
    },

    methods: {

    },

    // 钩子方法
    mounted() {
      //当DOM元素渲染完成后调用query

    }
  }
</script>
<style>

  .el-upload-list{
    display: none!important;
  }
</style>




// WEBPACK FOOTER //
// src/pages/sys/main.vue